import React from "react";
import { Fade } from "react-reveal";
import "./BestProcesses.css";
import { t } from "i18next";

function BestProcesses(props) {
  const theme = props.theme;

  return (
    <div className="projects-main">
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.we-use-the-best-processes")}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.home.we-use-the-best-processes.sub-title")}
              </p>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.home.we-use-the-best-processes.content")}
              </p>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default BestProcesses;
